export interface ErrorReporter {
  capture(error: unknown, context?: Record<string, string | number | boolean>): void;
}

export class ConsoleErrorReporter implements ErrorReporter {
  capture(error: unknown, context: Record<string, string | number | boolean> = {}): void {
    console.error("[treasure-grid]", error, context);
  }
}

export type SentryLike = {
  captureException(error: unknown, options?: { extra?: Record<string, string | number | boolean> }): void;
};

export class SentryErrorReporter implements ErrorReporter {
  constructor(private readonly client: SentryLike) {}
  capture(error: unknown, context: Record<string, string | number | boolean> = {}): void {
    this.client.captureException(error, { extra: context });
  }
}
